import { TextField } from "../../mui";

export const EmailComposerSubject = (props: {
  value: string | undefined;
  onChange: (value: string | undefined) => void;
}) => {
  return <TextField label="Subject" required value={props.value} onChange={(e) => props.onChange(e.target.value)} />;
};
